import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import { fetchMenu } from '@/actions/menu';
import { fetchMenusTaxonomy } from '@/actions/menuTaxonomy';
import Main from '@/layouts/Main';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import DetailImageContainer from '@/containers/menus/DetailImageContainer';
import DetailTitleContainer from '@/containers/menus/DetailTitleContainer';
import DetailGalleryContainer from '@/containers/menus/DetailGalleryContainer';
import DetailStep from '@/components/menus/DetailStep';
import DetailPoint from '@/components/menus/DetailPoint';
import DetailQuote from '@/components/menus/DetailQuote';
import DetailAuthor from '@/components/menus/DetailAuthor';
import DetailTag from '@/components/menus/DetailTag';
import DetailMaterial from '@/components/menus/DetailMaterial';
import DetailTool from '@/components/menus/DetailTool';
import DetailAction from '@/components/menus/DetailAction';
import MenuCarouselList from '@/components/menus/MenuCarouselList';
import ShoppingCarouselList from '@/components/shoppings/ShoppingCarouselList';
import MenuTaxonomyCategoryListContainer from '@/containers/menus/MenuTaxonomyCategoryListContainer';
import styles from 'styles/jss/original/pages/menus/slug';
import { MENU_SAME_CATEGORY, MENU_RELATION_SHOPPING } from '@/constants/app';
import { SITE_TITLE, SITE_DESCRIPTION } from '@/config/meta';
import _ from 'lodash';
import { useMedia } from 'react-use';
import basicAuthentication from '@/lib/basicAuthentication';
import useMenuDetail from '@/hooks/useMenuDetail';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const MenuPost: NextPage = () => {
  const classes = useStyles();
  const isSp = useMedia('(max-width:640px)');
  const router = useRouter();
  const [menu, menuList, shoppingList, error] = useMenuDetail();
  useEffect(() => {
    if (error) {
      _.defer(() => router.replace('/404'));
    }
  }, [error, router]);
  if (error || !menu) return null;
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={`${menu.fields.title} | ${SITE_TITLE}`}
          description={`${menu.fields.desc} | ${SITE_DESCRIPTION}`}
          image={`https:${menu.fields.mainImage.fields.file.url}`}
          url={`https://smalldish.jp/menus/${menu.fields.slug}`}
        />
        <div className={classes.main}>
          <DetailTitleContainer menu={menu} />
          <DetailImageContainer menu={menu} />
          <DetailGalleryContainer menu={menu} />
          <div className={classes.container}>
            <GridContainer>
              {/* @ts-expect-error */}
              <GridItem md={8} sm={8}>
                <DetailStep menu={menu} />
                <DetailPoint menu={menu} />
                <DetailQuote menu={menu} />
                <DetailAuthor menu={menu} />
              </GridItem>
              {/* @ts-expect-error */}
              <GridItem md={4} sm={4}>
                <DetailTag menu={menu} />
                <DetailMaterial menu={menu} />
                <DetailTool menu={menu} />
              </GridItem>
            </GridContainer>
          </div>
          <MenuCarouselList title={MENU_SAME_CATEGORY} menuList={menuList} />
          <ShoppingCarouselList title={MENU_RELATION_SHOPPING} shoppingList={shoppingList} />
          <MenuTaxonomyCategoryListContainer />
          <BottomBanner />
        </div>
        {isSp && <DetailAction menu={menu} />}
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ query, store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await Promise.all([
    (store.dispatch as AppDispatch)(fetchMenu(query.slug)),
    (store.dispatch as AppDispatch)(fetchMenusTaxonomy())
  ]);
});

export default MenuPost;
